const Button = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  ...props
}) => {
  const baseStyles =
    "inline-flex items-center justify-center rounded font-bold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-600 disabled:opacity-50 disabled:pointer-events-none cursor-pointer";

  const variants = {
    primary: "bg-custom-blue text-white hover:bg-[#001f38]",
    secondary:
      "border border-custom-blue text-custom-blue hover:bg-srp-foam",
    outline: "border border-stone-300 bg-white text-gray-900 hover:bg-stone-50",
    ai: "bg-custom-blue text-white hover:bg-[#001f38] motion-safe:hover:scale-105",
    danger: "bg-red-700 text-white hover:bg-red-800",
  };

  const sizes = {
    sm: "h-8 px-3 text-sm",
    md: "px-6 py-2.5 text-sm",
    lg: "h-12 px-6 text-base",
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
